import React from 'react'
import { SimpleMessagePage } from '../../components'

const ComingSoon: React.FC = () => <SimpleMessagePage messageKey="comingSoon" />

export default ComingSoon
